import React from 'react';
import { observer } from 'mobx-react-lite';
import { useRootStore } from '../../../../mobx/bridge';
import styles from './CannedMessage.module.css';
import * as utils from '../../../../helpers/utils';
import { getCustomerFromSmsChannel } from '../../../../helpers/contactHelpers';

// eslint-disable-next-line prefer-arrow-callback,sonarjs/cognitive-complexity
const CannedMessage = observer(function CannedMessage(props) {
  const { message, isSMSChannel, isWebChatChannel } = props;

  const { commonStore, sendingEvents, settingsStore } = useRootStore();

  const setSelectedCannedMessage = () => {
    const settings = settingsStore.getLoggedUserSettings;

    let cannedMessageText = message.Text;

    if (
      cannedMessageText?.includes('[COMPANY_PHONE]') ||
      cannedMessageText?.includes('[PHONE_NUMBER]')
    ) {
      cannedMessageText = cannedMessageText.replace(
        /\[COMPANY_PHONE\]|\[PHONE_NUMBER\]/g,
        commonStore?.locationTrackingNumber?.Number || ''
      );
    }

    if (cannedMessageText?.includes('[FIRST_NAME]')) {
      let contact;

      if (settings?.SelectedChannel?.ChannelType?.TypeId === utils.ChannelTypeEnum.SMS.TypeId) {
        contact = getCustomerFromSmsChannel(settings.SelectedChannel);
      } else if (
        settings?.SelectedChannel?.ChannelType?.TypeId === utils.ChannelTypeEnum.WebChat.TypeId
      ) {
        contact = settings.SelectedChannel.Contacts.find(
          (c) => c.ContactType.TypeId === utils.ContactTypeEnum.WebChatContact.TypeId
        );
      }

      if (contact?.FirstName) {
        cannedMessageText = cannedMessageText.replace(/\[FIRST_NAME\]/g, contact.FirstName || '');
      } else {
        cannedMessageText = cannedMessageText.replace(/(\s*)\[FIRST_NAME\](\s*)/g, '');
      }
    }

    if (cannedMessageText?.includes('[COMPANY_NAME]')) {
      cannedMessageText = cannedMessageText.replace(
        /\[COMPANY_NAME\]/g,
        commonStore?.selectedLocation?.LocationName || ''
      );
    }

    commonStore.setSelectedCannedMessage(cannedMessageText);

    if (settings?.SelectedChannel?._id) {
      sendingEvents.socketEmitContactStartedTyping({
        channelId: settings.SelectedChannel._id,
        contactId: commonStore.getLoggedUser._id,
      });
    }
  };

  const cannedMessageBtnStyles = [styles.cannedMessageBtn];
  if (isSMSChannel) {
    cannedMessageBtnStyles.push(styles.cannedMessageBtnGreen);
  } else if (isWebChatChannel) {
    cannedMessageBtnStyles.push(styles.cannedMessageBtnBlue);
  }

  return (
    <button
      type="button"
      className={cannedMessageBtnStyles.join(' ')}
      onClick={setSelectedCannedMessage}
      data-testid="cannedMessageBtn"
    >
      {message.Text}
    </button>
  );
});
CannedMessage.whyDidYouRender = true;
CannedMessage.displayName = 'CannedMessage';

export default CannedMessage;
